export default {
  name: 'marking--directionType',
};